import React from 'react';
import { formatDate } from '../../../data/utils/formatDate';
import { oddToString } from '../../../data/utils/oddToString';

function FlashbetTicketSelections(props) {
	const ticketData = props.ticketData;
	const selections = ticketData.events;

	const fixedStyle = {
        border: '1px solid black',
        float: 'right'
    };
	
	return (
        <div className={"container border-2px" + (ticketData.purchaseType === 'systembets'? "" : " border-bottom-none")} id="scommesse-container">
            {selections.map(function(selection) {
                const bets = selection.bets;
                const fixed = selection.fixed;
                const reactKey = 'ticket-selection-' + selection.pal + "-" + selection.avv;
                return (
                    <div className={"border-bottom"} key={reactKey}>
                        {bets.map(function(bet, index) {
                            const betReactKey = reactKey + '-bet-' + bet.scomSogei + '-' + bet.handicap + '-' + bet.codDraw;
                            let descScom = bet.printableDescScom;
                            let descDraw = bet.printableDescDraw;
                            const odd = oddToString(bet.odd);
                            
                            let descManif = '';
                            let descEvent = '';
                            let uniqueId = '';
                            if (index === 0) {
                                uniqueId = selection.alias;
                                if (uniqueId == null || uniqueId.length === 0) {
                                    uniqueId = selection.pal + "." + selection.avv;
                                }
                                if (selection.descCategory != null && selection.descCategory.length > 0) {
                                    descManif = selection.descCategory;
                                }
                                if (selection.descTournament != null && selection.descTournament.length > 0) {
                                    descManif = descManif + " " + selection.descTournament;
                                }
                                
                                descManif = descManif + (descManif.length > 0? ' ':'') + formatDate(selection.timestamp).formatted;
                                descEvent = selection.descAvv;
                            }
                            
                            return (
                                <React.Fragment key={betReactKey}>
                                    <span>{descManif} {fixed ? <span style={fixedStyle} className="bold" >F</span> : '' }</span>
                                    <div className="border-bottom-dashed">
                                        <p> {uniqueId} <span className="bold">{descEvent}</span></p>
                                    </div>
                                    <div className="d-flex-container">
                                        <span>{descScom}</span>
                                        <span className="bold">{descDraw}</span>
                                        <span className="bold">{odd}</span>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                );
            })}
        </div>
	);
}

export default FlashbetTicketSelections;